/* eslint-disable max-len, react/jsx-tag-spacing */
import React from 'react';
export var ICONS = {
  IconUULogoLoader: {
    viewBox: '0 0 122 156',
    markup: /*#__PURE__*/React.createElement("g", {
      id: "uu-logo",
      fill: "#2C405A"
    }, /*#__PURE__*/React.createElement("path", {
      id: "part-1",
      d: "M33.62,152 C26.9819212,147.782807 22.9722259,140.454352 23,132.59 L23,39.73 C22.9906064,23.3263177 14.2204359,8.17680147 0,0 L0,113.47 L0.17,113.47 C2.22940551,137.210507 22.0604767,155.458389 45.89,155.540069 C41.5466032,155.550677 37.2902063,154.32267 33.62,152 Z"
    }), /*#__PURE__*/React.createElement("path", {
      id: "part-2",
      d: "M55.72,132.6 L55.72,96.85 C55.7441166,74.1694004 47.6007635,52.2384347 32.78,35.07 L32.78,132.6 C32.78,145.269412 43.0505878,155.54 55.72,155.54 L78.66,155.54 C65.9905878,155.54 55.72,145.269412 55.72,132.6"
    }), /*#__PURE__*/React.createElement("path", {
      id: "part-3",
      d: "M78.66,149.06 C80.0272659,149.056768 81.3424033,148.535001 82.34,147.6 C86.9,144.04 88.78,139.06 88.78,132.6 L88.78,35.07 C73.9553193,52.236119 65.8114042,74.1685983 65.84,96.85 L65.84,132.6 C65.8229547,135.337738 65.3043914,138.04918 64.31,140.6 C67.1977338,145.815692 72.6982966,149.043199 78.66,149.02"
    }), /*#__PURE__*/React.createElement("path", {
      id: "part-4",
      d: "M98.61,132.59 L98.61,39.73 C98.6049671,23.3381553 107.35115,8.1905593 121.55,1.42108547e-14 L121.55,113.47 L121.39,113.47 C119.399287,137.244199 99.5273963,155.529641 75.67,155.54 C81.7557993,155.540001 87.592194,153.121742 91.8945661,148.817494 C96.1969382,144.513247 98.6126529,138.675799 98.61,132.59"
    }), /*#__PURE__*/React.createElement("polygon", {
      id: "part-5",
      points: "49.89 38.68 54.05 25.87 43.15 17.96 56.62 17.96 60.78 5.15 64.94 17.96 78.41 17.96 67.51 25.87 71.68 38.68 60.78 30.76"
    }))
  }
};

/* ------------ */